import { render, staticRenderFns } from "./agreeMentModal.vue?vue&type=template&id=faa43508&scoped=true"
import script from "./agreeMentModal.vue?vue&type=script&lang=js"
export * from "./agreeMentModal.vue?vue&type=script&lang=js"
import style0 from "./agreeMentModal.vue?vue&type=style&index=0&id=faa43508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa43508",
  null
  
)

export default component.exports